export default __webpack_public_path__ + "assets/horizontal-dots.8b1da63d.webp";